import { CleanButton, breakpoints, theme } from '@gassan-ui'
import styled from 'styled-components'

export const ContentBox = styled.div<{ columns: number }>`
  @media screen and (min-width: ${breakpoints.xlarge}) {
    columns: ${(p) => p.columns};
    column-gap: 3.5rem;
  }
`

export const NavButton = styled(CleanButton)<{ isLeft?: boolean }>`
  display: none;
  @media screen and (min-width: ${breakpoints.large}) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 4rem;
    width: 4rem;
    background: ${(p) => p.theme.colors.shades[200]};
    border-radius: 100%;
    bottom: -2rem;
    right: ${(p) => (p.isLeft ? '5.5rem' : '0')};
  }
  @media screen and (min-width: ${breakpoints.xxlarge}) {
    right: ${(p) => (p.isLeft ? 'auto' : '-4rem')};
    left: ${(p) => (p.isLeft ? '-4rem' : 'auto')};
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
    background: none;
  }
  @media screen and (min-width: 1700px) {
    right: ${(p) => (p.isLeft ? 'auto' : '-6rem')};
    left: ${(p) => (p.isLeft ? '-6rem' : 'auto')};
  }

  &:disabled {
    pointer-events: none;

    svg {
      opacity: 0.25;
    }
  }
`

export const ImageBox = styled.div<{ isLogo: boolean }>`
  ${(p) =>
    p.isLogo &&
    `
    background: white;
    padding: 1rem;
    border: 1px solid ${theme.colors.eagle};
  `}
`

export const SlideContainer = styled.div`
  display: block;
  margin-right: 4rem;
  min-width: 100%;
  scroll-snap-align: start;

  @media screen and (min-width: ${breakpoints.large}) {
    align-items: flex-start;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 3rem;
  }

  @media screen and (min-width: ${breakpoints.xlarge}) {
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 6rem;
  }
`
